const dayjs = require('dayjs');
const moment = require('moment');

const filter = {
    // 字符串截取
    subString(value, length) {
        if (!value) {
            return '';
        }
        value = value.trim();
        if (value.length > length) {
            var first = value.toString().substring(0, length);
            value = first + '...';
        }
        return value;
    },
    // 字符串截取
    cutString(value, length) {
        if (!value) {
            return '';
        }
        let val = value.toString().substring(0, length);
        return val;
    },
    // 数字处理
    numberFormat(value) {
        value = parseInt(value);
        if (isNaN(value)) {
            return 0;
        }

        if (value >= 10000) {
            value = value + '';
            var len = value.length;
            value = value.slice(0, len - 3);
            return parseFloat(value / 10) + '万';
        } else {
            return value;
        }
    },
    //日期处理
    filterTime(val, format) {
        if (!val) {
            return '-';
        }
        if (val) {
            format = format || 'YYYY-MM-DD HH:mm:ss';
            return dayjs(val).format(format);
        }
    },
    //转换日期格式
    showdate(content) {
        var val = '';
        if (content.length === 10) {
            const dataArr = content.split('-');
            val = dataArr[0] + '年 ' + dataArr[1] + '月 ' + dataArr[2] + '日';
        } else {
            val = content;
        }
        return val;
    },
    getDistanceDays(time) {
        // 当前时间的时间戳
        var nowTime = Date.parse(new Date());
        // 指定时间的时间戳
        var endTime = Date.parse(new Date(time));
        if (endTime < nowTime) {
            //  截止时间已过
            const timeResult = nowTime - endTime;
            const days = Math.floor(timeResult / (24 * 3600 * 1000));
            return `已过${days}`;
        } else {
            // 计算相差天数
            const timeResult = endTime - nowTime;
            const days = Math.floor(timeResult / (24 * 3600 * 1000));
            return `剩余${days}`;
        }
    },
    // 获取两个日期差异天数
    getDiffDay(date_1, date_2) {
        // 计算两个日期之间的差值
        let totalDays, diffDate;
        let myDate_1 = Date.parse(date_1);
        let myDate_2 = Date.parse(date_2);
        // 将两个日期都转换为毫秒格式，然后做差
        diffDate = Math.abs(myDate_1 - myDate_2); // 取相差毫秒数的绝对值
        totalDays = Math.floor(diffDate / (1000 * 3600 * 24)); // 向下取整
        return totalDays; // 相差的天数
    },
    //计算本上下季度
    /*
        type = 's'为开始时间，type='e'季度结束时间
        n = 0, -1, 1(本，上，下季度)
    */
    getQuater(type, n) {
        let currentQuarter = moment().quarter(); // 当前是第几季度
        let currentYear = moment().year(); // 当前年
        let getQuar = currentQuarter + n;
        // 本季度开始
        if (type == 's') {
            let startMoth = moment(moment(currentYear + '-01-01').toDate()).quarter(getQuar);
            return moment(startMoth).format('YYYY-MM-DD');
        } else if (type == 'e') {
            let endMonth = 3 * parseInt(getQuar); //当季度最后一个月
            /* 对月数进行格式化 */
            if (endMonth < 10) endMonth = '0' + endMonth;
            else endMonth += '';
            let endMonthDays = moment(currentYear + '-' + endMonth).daysInMonth(); // 末尾月天数
            let endDays = currentYear + '-' + endMonth + '-' + endMonthDays; //完整年月日整合
            return moment(endDays).format('YYYY-MM-DD');
        }
    },
    //性别
    filterSex(num) {
        var m = new Map([
            ['1', '男'],
            ['2', '女']
        ]);
        return m.get(num + '');
    },
    //证件类型
    filterCardType(num) {
        const m = new Map([
            ['01', '身份证'],
            ['02', '护照'],
            ['03', '军人证'],
            ['99', '其它'],
            ['06', '户口本'],
            ['04', '出生证'],
            ['08', '港澳台通行证'],
            ['05', '港澳台同胞证'],
            ['07', '港澳居民来往内地通行证'],
            ['09', '出生证明'],
            ['10', '企业三合一证'],
            ['11', '组织机构代码'],
            ['12', '工商注册号'],
            ['13', '统一社会信用代码'],
            ['14', '港澳居民居住证'],
            ['15', '台湾居民居住证'],
            ['16', '台湾居民来往大陆通行证'],
            ['17', '港澳台居民居住证'],
            ['19', '外国人永久居留身份证'],
        ]);
        return m.get(num);
    },
    //商户订单状态
    filterOrderStatus(num) {
        const m = new Map([
            ['1', '未支付'],
            ['2', '已付款'],
            ['3', '已退款'],
            ['4', '已失效'],
            ['-1', '未核保'],
            ['-3', '预核保失败'],
            ['10', '预核保成功']
        ]);
        return m.get(num + '');
    },
    //保单状态
    filterInsureOrderStatus(num) {
        const m = new Map([
            ['1', '已承保'],
            ['-1', '已退保'],
            ['0', '已终止'],
            ['2', '已中止']
        ]);
        return m.get(num + '');
    },
    //回访状态
    filterVerifyStatus(num) {
        const m = new Map([
            ['0', '等待回访'],
            ['1', '回访成功'],
            ['2', '回访失败'],
            ['3', '无需回访']
        ]);
        return m.get(num + '');
    },
    //商户订单详情状态
    filterOrderDetailStatus(num) {
        const m = new Map([
            ['-4', '已退款'],
            ['-3', '退款处理中'],
            ['-2', '已失效'],
            ['-1', '已关闭'],
            ['0', '支付失败'],
            ['1', '下单待支付'],
            ['2', '支付成功']
        ]);
        return m.get(num + '');
    },
    //商户缴费类型
    filterPayType(num) {
        const m = new Map([
            ['1', '年交'],
            ['2', '季交'],
            ['3', '月交'],
            ['4', '日交'],
            ['5', '半年交'],
            ['6', '岁交']
        ]);
        return m.get(num + '');
    },
    //与被保险人关系
    filterRelationShip(num) {
        const m = new Map([
            ['1', '本人'],
            ['2', '父母'],
            ['3', '子女'],
            ['4', '配偶'],
            ['30', "孙子女"],
			['31', "外孙子女"],
			['99', "其他"],
        ]);
        return m.get(num + '');
    },
    //收益人类型
    filterBeneficiaryType(num) {
        const m = new Map([
            ['1', '法定受益人'],
            ['2', '指定受益人']
        ]);
        return m.get(num + '');
    },
    //处理金额格式
    number_format(number, decimals, dec_point, thousands_sep) {
        /*
         * 参数说明：
         * number：要格式化的数字
         * decimals：保留几位小数
         * dec_point：小数点符号
         * thousands_sep：千分位符号
         * */
        number = (number + '').replace(/[^0-9+-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
            dec = typeof dec_point === 'undefined' ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.floor((n * 1).mul(k)).div(k);
            };
        s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.');
        var re = /(-?\d+)(\d{3})/;
        while (re.test(s[0])) {
            s[0] = s[0].replace(re, '$1' + sep + '$2');
        }

        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    },

    // 树状结构数据扁平化
    treeFlatArr(arr) {
        let data = JSON.parse(JSON.stringify(arr)); // 对传入的参数进行深拷贝
        let newData = []; // 创建空数组用来接收操作后的新数组
        const hasChildren = item => {
            // 递归遍历，把包含children的选项拿出来，push到之前新建的空数组内
            (item.children || (item.children = [])).map(v => {
                hasChildren(v);
            });
            delete item.children; // 删除原children属性，可选项
            newData.push(item);
        };
        data.map(v => hasChildren(v));
        return newData;
    },

    /**
     * 构造树型结构数据
     * @param {*} data 数据源
     * @param {*} id id字段 默认 'id'
     * @param {*} parentId 父节点字段 默认 'parentId'
     * @param {*} children 孩子节点字段 默认 'children'
     */
    handleTree(data, id, parentId, children) {
        let config = {
            id: id || 'id',
            parentId: parentId || 'parentId',
            childrenList: children || 'children'
        };

        var childrenListMap = {};
        var nodeIds = {};
        var tree = [];

        for (let d of data) {
            let parentId = d[config.parentId];
            if (childrenListMap[parentId] == null) {
                childrenListMap[parentId] = [];
            }
            nodeIds[d[config.id]] = d;
            childrenListMap[parentId].push(d);
        }

        for (let d of data) {
            let parentId = d[config.parentId];
            if (nodeIds[parentId] == null) {
                tree.push(d);
            }
        }

        for (let t of tree) {
            adaptToChildrenList(t);
        }

        function adaptToChildrenList(o) {
            if (childrenListMap[o[config.id]] !== null) {
                o[config.childrenList] = childrenListMap[o[config.id]];
            }
            if (o[config.childrenList]) {
                for (let c of o[config.childrenList]) {
                    adaptToChildrenList(c);
                }
            }
        }
        return tree;
    }
};
module.exports = filter;
